import './styles.scss'

import { Text } from "@fragments";

export default function SidebarItem({ left, right, onClick, text, className = "", active = false, comingSoon = false }) {
    return (
        <div
            className={`cs-sidebar-item ${active ? 'active' : ''} ${comingSoon ? 'coming-soon' : ''} ${className}`}
            onClick={comingSoon ? undefined : onClick}
        >
            <div className="sidebar-item-left">
                {left}
            </div>
            <div className="sidebar-item-main">
                <Text.h6
                    weight={active ? 600 : 400}
                >
                    {text}
                </Text.h6>
                {comingSoon && (
                    <span className="coming-soon-badge">Em breve</span>
                )}
            </div>
        </div>
    )
}